import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

const shelfShape = ImmutablePropTypes.contains({
  userId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  privateByDefault: PropTypes.bool.isRequired,
  items: ImmutablePropTypes.list.isRequired,
  pagination: ImmutablePropTypes.map.isRequired,
  sort: ImmutablePropTypes.map.isRequired,
  facets: ImmutablePropTypes.list.isRequired
});

export default shelfShape;
